import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
  message_update: { [user_id: string]: string };
  message_readed: { [user_id: string]: string };
  calls: { [user_id: string]: string };
  loading: string[];
};

const initialState: State = {
  message_update: {},
  message_readed: {},
  calls: {},
  loading: [],
};

const authSlice = createSlice({
  name: 'realtime',
  initialState,
  reducers: {
    set_message_update: (
      state: State,
      action: PayloadAction<{ [key: string]: string }>
    ) => {
      state.message_update = action.payload;
    },
    set_message_readed: (
      state: State,
      action: PayloadAction<{ [key: string]: string }>
    ) => {
      state.message_readed = action.payload;
    },
    set_calls: (
      state: State,
      action: PayloadAction<{ [key: string]: string }>
    ) => {
      state.calls = action.payload;
    },
    set_loading: (state: State, action: PayloadAction<string[]>) => {
      state.loading = action.payload;
    },
  },
});

export default authSlice;

export const {
  set_message_update,
  set_message_readed,
  set_calls,
  set_loading,
} = authSlice.actions;
